import React, { useEffect, useState } from 'react';
import './GlobalToast.css';

interface ToastMessage {
    id: number;
    message: string;
}

const GlobalToast: React.FC = () => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    useEffect(() => {
        const prvHandleApiError = (event: Event) => {
            const customEvent = event as CustomEvent<string>;
            let text = customEvent.detail;
            if (typeof text === 'string' && text.toLowerCase().includes('network error')) {
                text = 'Error en el servidor';
            }
            const newMessage: ToastMessage = {
                id: Date.now(),
                message: text
            };
            setToasts((prev) => [...prev, newMessage]);

            setTimeout(() => {
                setToasts((prev) => prev.filter((t) => t.id !== newMessage.id));
            }, 5000);
        };

        window.addEventListener('api-error', prvHandleApiError);
        return () => window.removeEventListener('api-error', prvHandleApiError);
    }, []);

    if (toasts.length === 0) return null;

    return (
        <div className="global-toast-container">
            {toasts.map((toast) => (
                <div key={toast.id} className="global-toast">
                    {toast.message}
                </div>
            ))}
        </div>
    );
};

export default GlobalToast;
